/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import locale from './locale'
import Form from 'components/Form';

class ModalContent extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      formData: props.classData,
    }

    this.onChange = this.onChange.bind(this)
  }

  componentWillReceiveProps({classData}){
    this.setState({formData: classData})
  }

  onChange(formData) {
    this.setState({
      formData:{
        ...this.state.formData,
        ...formData
      }
    }, () => {
      this.props.onFormChange(formData)
    })
  }

  render() {
    const {formData} = this.state;
    let notifyOption = []

    for (let i = 1; i < 31; i++) {
      if(formData.billingMethod.feeType == 0){
        if ( i > 1 ){
          notifyOption.push({label: __('{i} days in advance', locale, {i: i}), value: i})
        }
        else {
          notifyOption.push({label: __('{i} day in advance', locale, {i: i}), value: i})
        }
      } else if (formData.billingMethod.feeType == 1){
        if ( i > 1 ){
          notifyOption.push({label: __('{i} lessons in advance', locale, {i: i}), value: i})
        }
        else {
          notifyOption.push({label: __('{i} lesson in advance', locale, {i: i}), value: i})
        }
      } else if (formData.billingMethod.feeType == 2){
        if ( i > 1 ){
          notifyOption.push({label: __('{i} hours in advance', locale, {i: i}), value: i})
        }
        else {
          notifyOption.push({label: __('{i} hour in advance', locale, {i: i}), value: i})
        }
      }
    }

    const schema = [
      {
        name: 'cName',
        label: __('Class Name', locale),
        type: 'text',
        required: true,
      },
      {
        name: 'billingMethod',
        label: __('Billing Types', locale),
        type: 'classBillingMethod',
        required: true,
        mode: this.props.mode
      },
      {
        name: 'costAlertRange',
        label: __('Notify me overdue fee...', locale),
        type: 'select',
        required: false,
        options: notifyOption,
        tip: __('Lesson Completion Rules', locale)
      },
      {
        name: 'costRule',
        placeholder: __('Attending counts as completion', locale),
        type: 'checkbox',
        required: false,
        disabled: true
      },
      {
        name: 'absentFlag',
        placeholder: __('Absence (without reason) counts as completion', locale),
        type: 'checkbox',
        required: false,
      },
      {
        name: 'cancelFlag',
        placeholder: __('Absence (with reason) counts as completion', locale),
        type: 'checkbox',
        required: false,
      },
    ];

    return (
      <div className='create-class-modal-content'>
        <Form
          onChange={this.onChange}
          schema={schema}
          formData={formData}
          formStyle='outline'
          getValidationRef={this.props.getValidationRef}
        />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/CreateClass/ModalContent.js